import { useRef } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { apiSetSubmitStage } from "utils/API/TrxNowAPI";
import { FooterNavigation, Header, PaginationHelper, TitleBar } from "webapp/components";
import { ContractSearchForm } from "webapp/components/Partner/LDS/ContractSearchForm";
import { AppState } from "webapp/enums/AppState";
import { devLog } from "utils/devLog";

export default function ContractSearch(props) {
  const { t } = useTranslation();

  const formRef = useRef();

  const [lastName, setLastName] = useState(
    props.context.state.MemberLookup.LastName || props.context.state.LastName || "",
  );
  const [last8Vin, setLast8Vin] = useState(props.context.state.MemberLookup.VIN || props.context.state.VIN || "");
  const [odometer, setOdometer] = useState(
    props.context.state.MemberLookup.Odometer || props.context.state.Odometer || "",
  );

  const onUserBack = () => {
    if (typeof props.onUserBack === "function") {
      props.onUserBack();
    }
  };

  const onUserNext = () => {
    /*if(typeof props.onUserNext === 'function'){
      props.onUserNext({
        lastName: lastName,
        last8Vin: last8Vin
      });
    }*/

    devLog("formRef", formRef);
    if (typeof formRef.current !== "undefined") {
      formRef.current.submit();
    }
  };

  const onUserCancel = () => {
    if (typeof props.onUserCancel === "function") {
      props.onUserCancel();
    }
  };

  const onFormLoad = (ref) => {
    devLog("onFormLoad", formRef, ref);
    formRef.current = ref;
    devLog("onFormLoad", formRef);
  };

  const onFormUpdate = (data) => {
    devLog("onFormUpdate", data);
    if (typeof data === "object") {
      if (typeof data.lastName === "string") {
        setLastName(data.lastName);
      }
      if (typeof data.last8Vin === "string") {
        setLast8Vin(data.last8Vin);
      }
      if (typeof data.odometer === "string") {
        setOdometer(parseInt(data.odometer));
      } else if (typeof data.odometer === "number") {
        setOdometer(data.odometer);
      }
    }
  };

  const onFormSubmit = (data) => {
    const context = props.context;
    const naviState = context.state.navigationService.getState(AppState.MemberSearch);
    devLog("ContractSearch", naviState);

    onFormUpdate(data);

    // the user confirmed their customer information
    // store it in state and move forward
    const nextState =
      naviState && typeof naviState.nextState === "number" ? naviState.nextState : AppState.ConfirmVehicle; // go to confirm vechicle info
    context.setState(
      {
        MemberLookup: {
          MemberNumber: "",
          LastName: lastName,
          VIN: last8Vin,
          Odometer: odometer,
        },
        Odometer: odometer,
        webAppState: nextState, // go to confirm vechicle info
      },
      () => {
        // after saving customer info:
        apiSetSubmitStage(
          context.state,
          nextState,
          context.state.DisablementAddress || "DisablementAddress Not Available",
        );
        context.saveWebAppState(context);
      },
    );
  };

  const LocateUserObj = {
    img: props.logo,
    fragment: (
      <>
        <p className="mb-0">
          <strong>{t("LDS.ContractSearch.TitleBar2")}</strong>
          <br />
        </p>
      </>
    ),
  };

  return (
    <div className="CustCollectPage">
      <Header currState={props.currState} onUserBack={onUserBack} information={t("LDS.ContractSearch.TitleBar1")} />
      <TitleBar data={LocateUserObj} />
      <PaginationHelper context={props.context} />

      <ContractSearchForm
        lastName={lastName}
        last8Vin={last8Vin}
        odometer={odometer}
        onFormUpdate={onFormUpdate}
        onFormLoad={onFormLoad}
        onSubmit={onFormSubmit}
        onUserCancel={onUserCancel}
        onNextClick={onUserNext}
      />
    </div>
  );
}
